import { FC, createContext, useContext } from 'react';

import { useToggle } from '~hooks/useToggle';

import { DashboardVariantV2CarrierHeaderExpandMoreContextValue } from './types';

const DashboardVariantV2CarrierHeaderExpandMoreContext =
  createContext<DashboardVariantV2CarrierHeaderExpandMoreContextValue>({
    expand: true,
    toggleExpand: () => {},
  });

export const useDashboardVariantV2CarrierHeaderExpandMoreContext =
  (): DashboardVariantV2CarrierHeaderExpandMoreContextValue =>
    useContext(DashboardVariantV2CarrierHeaderExpandMoreContext);

const DashboardVariantV2CarrierHeaderExpandMoreProvider: FC = ({
  children,
}) => {
  const [expand, toggleExpand] = useToggle(true);

  return (
    <DashboardVariantV2CarrierHeaderExpandMoreContext.Provider
      value={{ expand, toggleExpand }}
    >
      {children}
    </DashboardVariantV2CarrierHeaderExpandMoreContext.Provider>
  );
};

export default DashboardVariantV2CarrierHeaderExpandMoreProvider;
